import { useEffect, useState } from 'react'

import { CircularProgress } from '../NarusMaterial'

export const Preview = ({ base64, type, style = {} }) => {
  const [ url, setUrl ] = useState(null)

  useEffect(() => {
    if (base64) {
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const file = new Blob([ byteArray ], { type })
      const fileURL = URL.createObjectURL(file)
      setUrl(fileURL)

      return () => URL.revokeObjectURL(fileURL)
    }
  }, [ base64, type ])

  return url
    ? (
      <iframe
        src={url}
        style={{
          height: 'calc(100vh - 150px)',
          width: '100%',
          paddingLeft: 0,
          paddingRight: 0,
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'block',
          overflowY: 'auto',
          overflowX: 'auto',
          ...style
        }}
        title='Preview'
      />
    )
    : (
      <CircularProgress />
    )
}
